export default {
  FETCH_STATISTICS: 'FETCH_STATISTICS'
}
